import { Pipe, PipeTransform } from '@angular/core';
import { getPinataThumbnailUrl } from '../utils/pinata-thumbnail.util';

/**
 * Resolves a Pinata gateway URL to its resized/optimised form.
 *
 * This exists to be PURE. As a template function call --
 * `[src]="getPinataThumbnailUrl(asset?.preview_image, 88)"` -- the string was rebuilt on
 * every change-detection cycle, for every image on the page, and these lists render
 * dozens at a time under default change detection. A pure pipe is re-evaluated only
 * when its inputs change identity, so each URL is computed once per item.
 *
 *   <img [src]="asset?.preview_image | pinataThumbnail: 88">
 */
@Pipe({
    name: 'pinataThumbnail',
    standalone: true,
    pure: true
})
export class PinataThumbnailPipe implements PipeTransform {
    transform(url: string | null | undefined, width?: number): string | null | undefined {
        return getPinataThumbnailUrl(url, width);
    }
}
